/**
 * sendWithdrawn.ts — the send's door (2026-09-28, Malaika's false "couldn't
 * start this reply"). Its own leaf, imported by the request (client.ts) and
 * the session hook, so a test that stands the client module in for a fake
 * still gets the real check.
 */

/**
 * The turn request was not sent because the send-ack watchdog had already told
 * the person this reply did not start. Not a failure of the request: the
 * watchdog's card is the whole story, and the dispatcher adds nothing to it.
 */
export class SendWithdrawnError extends Error {
  constructor() {
    super('[Prest0nSession] turn request withdrawn: the send-ack watchdog already reported it as not started');
    this.name = 'SendWithdrawnError';
  }
}

export function isSendWithdrawnError(err: unknown): boolean {
  return err instanceof SendWithdrawnError
    || (typeof err === 'object' && err !== null && (err as { name?: unknown }).name === 'SendWithdrawnError');
}
